// The bell in the top bar. A small dot is a quiet "something new" hint, gone when there is nothing
// new; never a number, never red, and never a count of unread mail (invariant 8). The accessible
// label still says how many.
import { Bell } from "lucide-react";
import { useNotifications } from "@web/lib/notifyQueries";
import { useHiddenNotifications, notifyStore, useDrawerOpen } from "./notifyStore";
import { bellLabel } from "./wording";

export function NotificationsBell({ enabled }: { enabled: boolean }) {
  const unseen = useNotifications(true, enabled);
  const hidden = useHiddenNotifications();
  const open = useDrawerOpen();
  const count = (unseen.data ?? []).filter((n) => !hidden.has(n.id)).length;
  return (
    <button
      type="button"
      onClick={() => notifyStore.toggle()}
      aria-label={bellLabel(count)}
      aria-expanded={open}
      aria-haspopup="dialog"
      title="Notifications (G then N)"
      className="relative inline-flex size-10 shrink-0 items-center justify-center rounded-lg text-muted hover:bg-sunk hover:text-ink"
    >
      <Bell aria-hidden className="size-5" />
      {count > 0 ? (
        <span
          aria-hidden
          data-testid="bell-dot"
          className="absolute top-2 right-2 size-2 rounded-full bg-accent ring-2 ring-bg"
        />
      ) : null}
    </button>
  );
}
